export const BLOCK_TYPES = [
  { id: "right", color: "bg-blue-500", es: "Mover 15 pasos →", en: "Move 15 steps →" },
  { id: "left", color: "bg-blue-500", es: "← Mover 15 pasos", en: "← Move 15 steps" },
  { id: "jump", color: "bg-blue-500", es: "Saltar", en: "Jump" },
  { id: "say", color: "bg-violet-500", es: "Decir ¡Hola!", en: "Say Hello!" },
  { id: "spin", color: "bg-violet-500", es: "Girar 360°", en: "Turn 360°" },
  { id: "grab", color: "bg-cyan-500", es: "Si toca la estrella → recogerla", en: "If touching star → collect it" },
];

export const RECIPE = [
  { es: "Abre Scratch y en 'Elegir un objeto' dibuja o sube a Lumi. Agrega otro objeto: una estrella.", en: "Open Scratch and in 'Choose a Sprite' draw or upload Lumi. Add another sprite: a star.", blocks: [] },
  { es: "Haz que Lumi se mueva con las flechas del teclado.", en: "Make Lumi move with the arrow keys.", blocks: [["bg-yellow-400", "al presionar la bandera verde", "when green flag clicked"], ["bg-orange-400", "por siempre", "forever"], ["bg-cyan-500", "si ¿tecla flecha derecha presionada?", "if key right arrow pressed?"], ["bg-blue-500", "sumar 10 a x", "change x by 10"]] },
  { es: "Haz que la estrella caiga desde arriba en un lugar al azar.", en: "Make the star fall from the top at a random spot.", blocks: [["bg-blue-500", "ir a x: (número al azar) y: 180", "go to x: (pick random) y: 180"], ["bg-orange-400", "por siempre", "forever"], ["bg-blue-500", "sumar -5 a y", "change y by -5"]] },
  { es: "Crea una variable llamada 'Puntos' y empieza en 0.", en: "Create a variable called 'Score' starting at 0.", blocks: [["bg-orange-600", "dar a Puntos el valor 0", "set Score to 0"]] },
  { es: "Cuando la estrella toque a Lumi: suma un punto y vuelve arriba.", en: "When the star touches Lumi: add a point and go back up.", blocks: [["bg-cyan-500", "si ¿tocando a Lumi?", "if touching Lumi?"], ["bg-orange-600", "sumar 1 a Puntos", "change Score by 1"], ["bg-pink-500", "iniciar sonido 'Pop'", "start sound 'Pop'"], ["bg-blue-500", "ir a y: 180", "go to y: 180"]] },
  { es: "¡Haz clic en la bandera verde y juega! Luego invita a Spark como segundo jugador.", en: "Click the green flag and play! Then add Spark as a second player.", blocks: [] },
];

export const TOOLS = [
  { id: "scratchjr", name: "ScratchJr", age: "5-7", url: "https://www.scratchjr.org", color: "from-yellow-300 to-amber-400", es: "Versión para los más pequeños en tablet: bloques con dibujos, sin leer mucho.", en: "Tablet version for little ones: picture blocks, little reading." },
  { id: "scratch", name: "Scratch", age: "8+", url: "https://scratch.mit.edu", color: "from-orange-300 to-orange-500", es: "Gratis y en español. Arrastras bloques de colores como un rompecabezas para crear juegos y animaciones.", en: "Free. Drag colorful blocks like a puzzle to create games and animations." },
  { id: "gdevelop", name: "GDevelop", age: "10+", url: "https://gdevelop.io", color: "from-violet-400 to-purple-600", es: "El siguiente nivel: juegos 2D con eventos visuales ('si pasa esto → haz aquello') y muy poco código.", en: "The next level: 2D games with visual events ('if this happens → do that') and very little code." },
];

export const GAME_TEXT = {
  es: {
    title: "Taller de videojuegos de Spark",
    intro: "Con Scratch no necesitas escribir códigos complicados: armas tu juego uniendo bloques de colores como un rompecabezas.",
    builder: "Arma tu programa",
    builderSub: "Toca los bloques para agregarlos y presiona la bandera verde. ¡Lumi hará lo que digas!",
    run: "Ejecutar",
    clear: "Borrar",
    empty: "Toca bloques de abajo para armar tu programa",
    whenFlag: "Al presionar la bandera verde",
    got: "¡Lumi recogió la estrella!",
    game: "Juego: Lumi atrapa estrellas",
    gameSub: "Mueve a Lumi con las flechas, los botones o tu dedo. ¡Atrapa todas las estrellas en 30 segundos!",
    play: "Jugar",
    again: "Jugar otra vez",
    score: "Estrellas",
    time: "Tiempo",
    final: "¡Atrapaste {n} estrellas!",
    recipe: "Crea este juego en Scratch paso a paso",
    step: "Paso",
    tools: "Herramientas para crear juegos",
    open: "Abrir con un adulto",
    age: "Edad",
  },
  en: {
    title: "Spark's game workshop",
    intro: "With Scratch you don't need complicated code: build your game by snapping colorful blocks like a puzzle.",
    builder: "Build your program",
    builderSub: "Tap blocks to add them and press the green flag. Lumi will do what you say!",
    run: "Run",
    clear: "Clear",
    empty: "Tap blocks below to build your program",
    whenFlag: "When green flag clicked",
    got: "Lumi collected the star!",
    game: "Game: Lumi catches stars",
    gameSub: "Move Lumi with the arrows, the buttons or your finger. Catch all the stars in 30 seconds!",
    play: "Play",
    again: "Play again",
    score: "Stars",
    time: "Time",
    final: "You caught {n} stars!",
    recipe: "Build this game in Scratch step by step",
    step: "Step",
    tools: "Tools to create games",
    open: "Open with an adult",
    age: "Age",
  },
};
